import Button from "components/components/Button/Button";
import { useCustomerFeedbackModalContext } from "contexts/CustomerFeedbackModalContext";
import React, { useEffect, useState } from "react";
import {
  functionalityCookiesAreEnabled,
  HAS_COLLAPSED_BANNER_COOKIE,
  parseCookies,
  setCookieIfNotExists,
} from "utils/cookieHelper";

import {
  PhaseTag,
  HeaderRow,
  ExpandableDiv,
  StyledPhaseBanner,
  StyledSubtitle,
} from "./style";

const PhaseBanner: React.FC = () => {
  const { open: openCustomerFeedbackModal } = useCustomerFeedbackModalContext();
  const [expanded, setExpanded] = useState(false);
  const expanderButtonText = expanded ? "Show less" : "Learn more";

  useEffect(() => {
    const phaseBannerCookie = parseCookies(document.cookie)[
      HAS_COLLAPSED_BANNER_COOKIE
    ];
    if (!phaseBannerCookie) {
      setExpanded(true);
    }
  }, []);

  const expandOrCollapseBanner = (): void => {
    if (expanded) {
      const consent = functionalityCookiesAreEnabled();

      if (consent) {
        setCookieIfNotExists(HAS_COLLAPSED_BANNER_COOKIE, true.toString());
      }
    }

    setExpanded((v) => !v);
  };

  return (
    <>
      <StyledPhaseBanner aria-live="polite">
        <HeaderRow className="banner-row">
          <div>
            <PhaseTag>Beta</PhaseTag>
          </div>
          This is our Beta website publishing production BMRS data and we will
          be adding new features and data reports.
          <Button
            className="plain-inline align-right expander-button"
            aria-label={expanderButtonText}
            onClick={(): void => expandOrCollapseBanner()}
            buttonText={expanderButtonText}
          >
            <span className="expander-icon" aria-hidden="true">
              {expanded ? "3" : "o"}
            </span>
          </Button>
        </HeaderRow>
        {expanded && (
          <ExpandableDiv
            className="banner-row"
            data-test-id="phase-banner-content"
          >
            <div>
              <StyledSubtitle>About the BETA Phase</StyledSubtitle>
              <div>
                This website will remain in Beta where we will continue to add
                new content and data reports currently published on our BMRS
                website. The platform has been tested and meet our quality
                standards both for the data accuracy and application resilience,
                we expect further enhancement frequently without notice. This
                Beta version is open to all users and an opportunity to try new
                features, as you preview new design,{" "}
                <Button
                  ariaLabel="send us your feedback"
                  onClick={openCustomerFeedbackModal}
                  buttonText="send us your feedback"
                  className="plain-inline"
                />{" "}
                to help us create an exceptional experience using our service.
              </div>
            </div>
            <div>
              <StyledSubtitle>Data Quality</StyledSubtitle>
              <div>
                The reports published on the Insights Solution website and APIs
                is production data that is published on our BMRS website. This
                has been tested to ensure the data is accurate, complete and
                similar latency to data published on BMRS website.
              </div>
            </div>
          </ExpandableDiv>
        )}
      </StyledPhaseBanner>
    </>
  );
};

export default PhaseBanner;
